export * from './footer.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/footer/index.ts